import { render, staticRenderFns } from "./VpcTiersTab.vue?vue&type=template&id=275e7e44&scoped=true&"
import script from "./VpcTiersTab.vue?vue&type=script&lang=js&"
export * from "./VpcTiersTab.vue?vue&type=script&lang=js&"
import style0 from "./VpcTiersTab.vue?vue&type=style&index=0&id=275e7e44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275e7e44",
  null
  
)

export default component.exports